export default "__VITE_ASSET__NMpK185b__"